import React, { useState } from 'react';
import { Button, Form, Container, Row, Col } from 'react-bootstrap';
// import QRCodeGenerator from './QRCodeGenerator';
// import { useTranslation } from 'react-i18next';

// import CopyToClipboard from './NewCopyToClipboard';
// import translationES from './locales/es/translation.json';
// import translationFR from '../../public/locales/en/translation.json';
// import tran

// import LanguageSwitcher from './LanguageSwitcher';





const PasswordGenerator = () => {
    // const { t } = useTranslation();
    // const { t } = useTranslation();
    // i18n.use(initReactI18next).init({
    //     resources: {
    //       en: { translation: translationEN },
    //       tr: { translation: translationTR },
    //       // es: { translation: translationES },
    //       // fr: { translation: translationFR },
    //     },
    //     lng: 'en', // Default language
    //     fallbackLng: 'en',
    //     interpolation: {
    //       escapeValue: false,
    //     },
    //   });

//   const handleLanguageChange = (newLanguage) => {
//     i18n.changeLanguage(newLanguage);
//   };
  const [password, setPassword] = useState('');
//   const [qRCode, setQRCode] = useState(false);
  const [options, setOptions] = useState({
    includeCapital: true,
    includeLower: true,
    includeNumbers: true,
    includeSymbols: true,
    length: 12,
  });

  const generatePassword = () => {
    const characters = {
      capital: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      lower: 'abcdefghijklmnopqrstuvwxyz',
      numbers: '0123456789',
      symbols: '!@#$%^&*()_+-=[]{}|;:,.<>?',
    };

    let validChars = '';
    
    if (options.includeCapital) validChars += characters.capital;
    if (options.includeLower) validChars += characters.lower;
    if (options.includeNumbers) validChars += characters.numbers;
    if (options.includeSymbols) validChars += characters.symbols;

    let newPassword = '';
    for (let i = 0; i < options.length; i++) {
      const randomIndex = Math.floor(Math.random() * validChars.length);
      newPassword += validChars[randomIndex];
    }
    if(options.length < 8){
        alert('Password length should be greater then 8')
    }else if (options.length > 30){
        alert('Password length should be less then 30')
    }
    else if( options.includeCapital === false && options.includeLower === false && options.includeNumbers === false  && options.includeSymbols === false ){
        // setPassword("You haven't selected any character types");
        alert("You haven't selected any character types")
        // setQRCode(false);
    }
    
    else{
        setPassword(newPassword);
        // setQRCode(true);
    }
    
  };

  const handleOptionChange = (option) => {
    setOptions((prevOptions) => ({
      ...prevOptions,
      [option]: !prevOptions[option],
    }));
  };

  const handleLengthChange = (e) => {
    const newLength = parseInt(e.target.value, 10);
    setOptions((prevOptions) => ({
      ...prevOptions,
      length: isNaN(newLength) ? 0 : newLength,
    }));
  };

   const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Password'); // State for button label
  
    const handleCopy = (text) => {
      navigator.clipboard.writeText(text); // Copy text to clipboard
      setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
      setTimeout(() => setCopyButtonLabel('Copy Password'), 1500); // Revert back to "Copy Number" after 1.5 seconds
    };


    // Clear input fields
    const clearFields = () => {
      setPassword('');
    };


  return (
    <Container>
      <Row className="justify-content-md-center">
        <Col xs={12} md={8}>
          {/* <h1>Password Generator</h1> */}
        
          <br/>
          <Form style = {{textAlign: 'left'}}>
            <Form.Check
              type="switch"
            //   label="Include Capital Alphabets"
              label="Include Capital Alphabets"
              checked={options.includeCapital}
              onChange={() => handleOptionChange('includeCapital')}
            />
            <Form.Check
              type="switch"
            //   label="Include Lower Alphabets"
              label="Include Lower Alphabets"
              checked={options.includeLower}
              onChange={() => handleOptionChange('includeLower')}
            />
            <Form.Check
              type="switch"
            //   label="Include Numbers"
              label="Include Numbers"
              checked={options.includeNumbers}
              onChange={() => handleOptionChange('includeNumbers')}
            />
            <Form.Check
              type="switch"
            //   label="Include Symbols"
              label="Include Symbols"
              checked={options.includeSymbols}
              onChange={() => handleOptionChange('includeSymbols')}
            />
            <Form.Group controlId="formLength">
              {/* <Form.Label>Password Length:</Form.Label> */}
              <Form.Label>Password Length  </Form.Label>
              {/* <h1>{t('passwordGeneratorTitle')}</h1> */}
              <Form.Control
                type="number"
                min="1"
                value={options.length}
                onChange={handleLengthChange}
              />
            </Form.Group>
            <br/>
            <Button variant="primary" onClick={generatePassword}>
            Generated Password:
            </Button>
            <Button className="btn btn-danger mt-2" onClick={clearFields}>
            Clear
          </Button>
          <br/>
          <Button
            className="btn btn-primary mt-3"
            onClick={() => handleCopy(password)}
          >
            {copyButtonLabel}
          </Button>
          </Form>
          {password && (
            <div>
              <h2>Generated Password:</h2>
              
              <p>{password}</p>
              {/* <QRCodeGenerator password={password}  /> */}
             
              {/* <CopyToClipboard >{password}</CopyToClipboard> */}
          
            </div>
            
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default PasswordGenerator;
